module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentBadge) ? _c('div', {
    staticClass: "bdg__bg",
    on: {
      "click": _vm.resetCurrentBadge
    }
  }, [_c('div', {
    staticClass: "bdg__modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('img', {
    staticClass: "bdg__close",
    attrs: {
      "src": "/static/img/ic_close.svg"
    },
    on: {
      "click": _vm.resetCurrentBadge
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bdg__ill__container"
  }, [_c('img', {
    staticClass: "bdg__ill",
    class: {
      'closed': !_vm.currentBadge.isOpen
    },
    attrs: {
      "src": "/static/img/badge_ph.svg"
    }
  }), _vm._v(" "), (_vm.currentBadge.isNew) ? _c('div', {
    staticClass: "bdg__reward"
  }, [_vm._v("+10")]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "bdg__name"
  }, [_vm._v(_vm._s(_vm.currentBadge.name))]), _vm._v(" "), _c('p', {
    staticClass: "bdg__description"
  }, [_vm._v(_vm._s(_vm.currentBadge.description))])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0280f14f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pop-ups/badge-dets.vue
// module id = 392
// module chunks = 1